import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import * as moment from "moment";
import { Col, Row, Glyphicon, ButtonGroup, Button, ButtonToolbar, Tooltip, OverlayTrigger } from "react-bootstrap";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { Form } from "react-final-form";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { DotLoader } from "react-spinners";
import { consultarServiciosReciboSat } from "../../../general/modulos/maestrosActions";
import ModalXLSDatosGlosas from "../../inconsistencias/componentes/ModalXLSDatosGlosas";
import {
    documentoEmpleador,
    tipoDocumentoEmpleador,
    tipoTransaccion,
    fechaInicialConsulta,
    fechaFinalConsulta,
    estadosProceso,
    consecutivoSolicitud,
    tipoConssultaDetalle
} from "../../config_general/modelo/TextosAyuda";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import { listarServicios, listaEstadosReciboSAT, FiltroConsultaReciboDetalle } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import { EstadoReciboSAT } from "../../config_general_recibo/modelo/EstadoReciboSAT";
import { CODIGOS_CONSULTA } from "../../config_general_recibo/modelo/CodigosConsulta";
import { consultarNovedadesDetalle, consultarNovedadesDetalleXLS, limpiarMensajesEstado } from "../modulos/reciboNovedadesDetalleActions";
import DivisorConTexto from "../../config_general/componentes/DivisorConTexto";
import TablaConsultaDetalle from "./TablaConsultaDetalle";
import MensajeConAccion from "../../../general/componentes/MensajeConAccion";
import { ModalCambioEstado } from "./ModalCambioEstado";
import { ParametrosConsultaDetalle } from "../modelo/ParametrosConsultaDetalle";
import TextoInput from "../../../general/componentes/TextoInput";
import { DatosCambioEstado } from "../modelo/ConsultaNovedadesDetalle";
import { enviarCambioEstado } from "../modulos/reciboNovedadesDetalleActions";

class FiltroConsultaDetalle extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.generarXLS = this.generarXLS.bind(this);
        this.renderBotoneCambioEstado = this.renderBotoneCambioEstado.bind(this);


        this.state = {
            showModalXLS: false,
            maxRegistrosXLS: 10000,
            verModalCambioEstado: false,
            verBotonCambioEstado: false,
            estado: undefined,
            observacion: undefined,
            enviarCambiosEstado: false
        };
    }

    componentWillMount() {
        if (!this.props.serviciosReciboSat || this.props.serviciosReciboSat.length === 0) {
            this.props.dispatch(consultarServiciosReciboSat());
        }
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesEstado());
    }

    render() {
        const { totalRegistros } = this.props;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Detalle Novedades Recibidas SAT</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoTransaccion">Tipo de Transacción</label>
                                                <TextoAyuda texto={tipoTransaccion} />
                                                <TextoInputSelector name="tipoTransaccion" maestro={listarServicios(this.props.serviciosReciboSat)} />
                                                {errors.tipoTransaccion &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoTransaccion}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="tipoConsulta">Consultar por:</label>
                                                <TextoAyuda texto={tipoConssultaDetalle} />
                                                <TextoInputSelector name="tipoConsulta" maestro={this.listarTipoConsulta()} />
                                                {errors.tipoConsulta &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoConsulta}</span>
                                                    </div>
                                                }
                                            </Col>
                                            {
                                                values.tipoConsulta &&
                                                this.renderOpcionesConsulta(Number(values.tipoConsulta.value))
                                            }
                                        </Row>
                                        <br />
                                        <DivisorConTexto texto="opcional" />
                                        <br />
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TextoAyuda texto={tipoDocumentoEmpleador} />
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <TextoAyuda texto={documentoEmpleador} />
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={9}>
                                                <label>Estados</label>
                                                <TextoAyuda texto={estadosProceso} />
                                                <TextoInputSelector name="estados" selectorMultiple maestro={listaEstadosReciboSAT(EstadoReciboSAT)} />
                                                {errors.estados &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.estados}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `50px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {
                                                        (totalRegistros > 0) &&
                                                        <a className="btns btn-success" onClick={this.obtenerXLS}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.showModalXLS && this.mostrarModalXLS()}
                                                </Col>
                                                <Col sm={3}>
                                                    {this.state.verBotonCambioEstado && this.renderBotoneCambioEstado()}
                                                    {this.state.verModalCambioEstado && this.renderModalCambioEstado()}
                                                </Col>
                                                <Col smOffset={3} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderEstadoDescargaXLS()}
                    {this.renderEstadoEnvioCambioEstado()}
                    {this.renderTabla()}

                </Row>
            </div>
        );
    }

    renderOpcionesConsulta(codigoConsulta: number) {
        switch (codigoConsulta) {
            case 1:
                return (
                    <Col sm={5}>
                        <label htmlFor="consecutivoSolicitud">Consecutivo SAT</label>
                        <TextoAyuda texto={consecutivoSolicitud} />
                        <TextoInput name="consecutivoSolicitud" placeholder="Ingrese consecutivo transaccion" maxLength={50} />
                    </Col>
                );
            case 2:
                return (
                    <div>
                        <Col sm={3}>
                            <label>Fecha Inicial de Operación</label>
                            <TextoAyuda texto={fechaInicialConsulta} />
                            <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()} />
                        </Col>
                        <Col sm={3}>
                            <label>Fecha Final de Operación</label>
                            <TextoAyuda texto={fechaFinalConsulta} />
                            <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()} />
                        </Col>
                    </div>
                );
            default:
                return false;
        }
    }

    obtenerXLS = () => {
        const { totalRegistros } = this.props;
        if (totalRegistros < this.state.maxRegistrosXLS) {
            this.generarXLS(0);
        } else {
            this.setState({ showModalXLS: true });
        }
    };

    generarXLS(reporte: number) {
        const filtro: FiltroConsultaReciboDetalle = {
            dniEmpleador: this.state.dniEmpleador,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            servicio: this.state.servicio,
            estados: this.state.estados,
            consecutivoSolicitud: this.state.consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_DETALLE,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin,
            tamanoPagina: this.state.maxRegistrosXLS,
            paginaActual: reporte
        };
        this.props.dispatch(consultarNovedadesDetalleXLS(filtro));
    }

    mostrarModalXLS() {
        const { totalRegistros, tamanoPagina } = this.props;
        const reportesXLS = Math.ceil(totalRegistros / this.state.maxRegistrosXLS);
        const totalPaginas = Math.ceil(totalRegistros / tamanoPagina);
        return (
            <ModalXLSDatosGlosas
                totalGlosasConsulta={totalRegistros}
                reportesXLS={reportesXLS}
                totalPaginas={totalPaginas}
                showModalXLS={this.state.showModalXLS}
                closeModalXLS={() => this.handleCloseModalXLS()}
                generarXLS={this.generarXLS}
                maxRegistrosXLS={this.state.maxRegistrosXLS}
                tamanoPaginaFiltro={tamanoPagina}
            />
        );
    }

    handleCloseModalXLS() {
        this.setState({ showModalXLS: false });
    }

    renderModalCambioEstado() {
        return (
            <ModalCambioEstado
                obtenerDatosCambioEstado={this.obtenerDatosCambioEstado}
                cerrarModal={() => this.setState({ verModalCambioEstado: false })}
            />
        );
    }

    renderBotoneCambioEstado() {
        const tooltipGestiones = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>Cambiar Estado:</strong> Se usa para cambiar el estado de los registros seleccionados.
                </span>
            </Tooltip>
        );
        return (
            <div className="button-group-form">
                <ButtonToolbar className="button-group-toolbar">
                    <ButtonGroup>
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => this.setState({ verModalCambioEstado: true })}>
                            <Glyphicon glyph="refresh" /> &nbsp;Cambiar Estado
                        </Button>
                    </ButtonGroup>
                    <OverlayTrigger placement="top" overlay={tooltipGestiones}>
                        <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );

    }

    renderTabla() {
        const { estadoConsultaDetalle, detalleNovedades, tamanoPagina, paginaActual, paginas, totalRegistros } = this.props;
        switch (estadoConsultaDetalle) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!detalleNovedades || !detalleNovedades.length)
                    return (
                        <span>
                            <MensajeConAccion type={"info"} mensaje={"No se han encontrado mensajes"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaConsultaDetalle
                                registros={detalleNovedades}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                totalRegistros={totalRegistros}
                                consultaPaginada={this.consultaPaginada}
                                mostrarModalCambioEstado={this.mostrarModalCambioEstado}
                                enviarCambiosEstado={this.state.enviarCambiosEstado}
                                envioEstados={this.envioAccionCambioEstado}
                            />
                        </span>);
            default:
                return false;
        }
    }

    renderEstadoDescargaXLS() {
        const { estadoDescargaXLS } = this.props;
        switch (estadoDescargaXLS) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={"Se ha presentado un error al generar el reporte, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                        <br />
                    </div>);
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"} mensaje={"Se genero el reporte con exito"} />
                    </span>
                );
            default:
                return false;
        }
    }

    renderEstadoEnvioCambioEstado() {
        const { estadoEnvioCambioEstado } = this.props;
        switch (estadoEnvioCambioEstado) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={"Se ha presentado un error al crear el proceso de cambio de estado, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                        <br />
                    </div>);
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"} mensaje={"Se creó el proceso de cambio de estado con éxito"} />
                    </span>
                );
            default:
                return false;
        }
    }

    filtros(): FiltroConsultaReciboDetalle {
        return {
            dniEmpleador: this.state.dniEmpleador,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            servicio: this.state.servicio,
            estados: this.state.estados,
            consecutivoSolicitud: this.state.consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_DETALLE,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };
    }

    consultaPaginada = (filtro: FiltroConsultaReciboDetalle) => {
        this.props.dispatch(consultarNovedadesDetalle(filtro));
    };

    onSubmit = (values: any) => {
        this.props.dispatch(consultarNovedadesDetalle(this.obtenerValores(values)));
    };

    obtenerValores = (values: any) => {
        const consultaConConsecutivo = values.tipoConsulta.value === 1;
        const consultaConFechas = values.tipoConsulta.value === 2;

        const fechaInicial = values.fechaInicial && consultaConFechas ? values.fechaInicial.format("YYYY-MM-DD").valueOf() : undefined;
        const fechaFinal = values.fechaFinal && consultaConFechas ? values.fechaFinal.format("YYYY-MM-DD").valueOf() : undefined;
        const consecutivoSolicitud = values.consecutivoSolicitud && consultaConConsecutivo ? values.consecutivoSolicitud : undefined;

        const dni = (values.tipoDocumento && values.documento) ? (values.tipoDocumento + values.documento) : undefined;
        const tipoTransaccion = values.tipoTransaccion ? Number(values.tipoTransaccion.value) : undefined;
        const estados = (values.estados) ? values.estados.map(estado => estado.value) : undefined;

        const filtro: FiltroConsultaReciboDetalle = {
            dniEmpleador: dni,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            servicio: tipoTransaccion,
            estados: estados,
            consecutivoSolicitud: consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_DETALLE,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };

        this.setState({
            dniEmpleador: dni,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            servicio: tipoTransaccion,
            estados: estados,
            consecutivoSolicitud: consecutivoSolicitud,
            filtro: filtro
        });

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            tipoTransaccion: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined,
            documento: undefined,
            tipoDocumento: undefined,
            tipoConsulta: undefined,
            consecutivoSolicitud: undefined
        };

        if (!values.tipoTransaccion) {
            errors.tipoTransaccion = "Por favor seleccione una opción";
            return errors;
        }

        if (!values.tipoConsulta) {
            errors.tipoConsulta = "Por favor seleccione una opción";
            return errors;
        }

        if (values.tipoConsulta.value === 1 && !values.consecutivoSolicitud) {
            errors.consecutivoSolicitud = "Ingrese un consecutivo";
            return errors;
        }

        if (values.tipoConsulta.value === 2) {
            if (!values.fechaInicial) {
                errors.fechaInicial = "Por favor seleccione una fecha";
                return errors;
            }
            if (!values.fechaFinal) {
                errors.fechaFinal = "Por favor seleccione una fecha";
                return errors;
            }
            if (values.fechaInicial.isAfter(values.fechaFinal)) {
                errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
                return errors;
            }
        }


        if (values.tipoDocumento && !values.documento)
            errors.documento = "Se debe ingresar el numero de documento";

        if (values.documento && !values.tipoDocumento)
            errors.tipoDocumento = "Se debe seleccionar el tipo de documento";

        return errors;
    };

    mostrarModalCambioEstado = (activar: boolean) => {
        this.setState({ verBotonCambioEstado: activar });
    };

    obtenerDatosCambioEstado = (estado: number, observacion: string) => {
        this.setState({
            estado: estado,
            observacion: observacion,
            enviarCambiosEstado: true
        });
    }

    envioAccionCambioEstado = (consecutivos: Array<number>, servicio: number) => {
        const datosEnvio: DatosCambioEstado = {
            servicio: servicio,
            consecutivos: consecutivos,
            estado: Number(this.state.estado),
            observacion: this.state.observacion,
            dniUsuario: this.props.dniUsuarioGestionLogin
        };
        this.props.dispatch(enviarCambioEstado(datosEnvio));
        this.setState({
            estado: undefined,
            observacion: undefined,
            enviarCambiosEstado: false
        });
    };

    listarTipoConsulta = () => {
        return [].concat(
            ParametrosConsultaDetalle.map(value => ({
                value: value.codigo,
                label: value.opcion
            })
            ));
    };
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        detalleNovedades: R.pathOr([], ["recibo_detalle_novedades", "detalleNovedades"])(store),
        paginas: R.pathOr(0, ["recibo_detalle_novedades", "paginas"])(store),
        totalRegistros: R.pathOr(0, ["recibo_detalle_novedades", "totalRegistros"])(store),
        paginaActual: R.pathOr(0, ["recibo_detalle_novedades", "paginaActual"])(store),
        tamanoPagina: R.pathOr(10, ["recibo_detalle_novedades", "tamanoPagina"])(store),
        estadoDescargaXLS: R.pathOr(undefined, ["recibo_detalle_novedades", "estadoDescargaXLS"])(store),
        estadoEnvioCambioEstado: R.pathOr(undefined, ["recibo_detalle_novedades", "estadoEnvioCambioEstado"])(store),
        estadoConsultaDetalle: R.pathOr(undefined, ["recibo_detalle_novedades", "estadoConsultaDetalle"])(store),
        serviciosReciboSat: R.pathOr([], ["maestros", "serviciosReciboSat"])(store)
    };
})(FiltroConsultaDetalle);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_detalle/componentes/FiltroConsultaDetalle.tsx